export const villageInfants = [
  {
    id: "inf001",
    name: "小明",
    age: "8个月",
    village: "云南省昭通市彝良县小草坝村",
    province: "云南",
    story: "小明的父母在外务工，由年迈的奶奶照料。家中经济困难，奶奶每天只能用稀粥喂养小明，营养严重不足。小明特别喜欢看色彩鲜艳的图画书，每次看到书本都会咯咯笑。",
    needs: ["奶粉", "图画书", "营养辅食"],
    goalAmount: 1200,
    raisedAmount: 980,
    donors: 23,
    image: "https://public.readdy.ai/ai/img_res/5dad9881cb9f6ead37e457e8d6b82669.jpg",
    thankYouMessage: "谢谢叔叔阿姨，我会好好长大，将来报答大家的爱！",
    status: "urgent",
    receivedGifts: ["奶粉 × 3罐", "图画书 × 2本"],
  },
  {
    id: "inf002",
    name: "小花",
    age: "6个月",
    village: "贵州省毕节市威宁县石门乡",
    province: "贵州",
    story: "小花是双胞胎之一，妈妈产后身体虚弱无法哺乳，爸爸在矿山打工，一个月才能回家一次。小花和姐姐每天只能喝米汤，急需奶粉和营养品。",
    needs: ["奶粉", "营养品", "婴儿衣物"],
    goalAmount: 1500,
    raisedAmount: 1200,
    donors: 31,
    image: "https://readdy.ai/api/search-image?query=adorable%20Chinese%20baby%20girl%20in%20rural%20village%2C%20sweet%20innocent%20face%2C%20simple%20traditional%20clothing%2C%20sitting%20in%20bamboo%20basket%2C%20warm%20sunlight%2C%20heartwarming%20rural%20China%20baby%20portrait%2C%20gentle%20soft%20photography%2C%20clean%20natural%20background&width=400&height=400&seq=infant002&orientation=squarish",
    thankYouMessage: "等我长大了，我要成为像您一样有爱心的人！",
    status: "urgent",
    receivedGifts: ["奶粉 × 2罐", "婴儿衣物 × 1套"],
  },
  {
    id: "inf003",
    name: "小强",
    age: "10个月",
    village: "四川省凉山彝族自治州布拖县",
    province: "四川",
    story: "小强生活在大凉山深处，父母因病去世，由外公外婆抚养。外公外婆年迈体弱，靠种地维持生计，无力购买奶粉和书籍。小强眼睛特别明亮，充满对世界的好奇。",
    needs: ["奶粉", "图画书", "玩具"],
    goalAmount: 1000,
    raisedAmount: 650,
    donors: 18,
    image: "https://readdy.ai/api/search-image?query=cute%20Chinese%20baby%20boy%20from%20mountain%20village%2C%20bright%20curious%20eyes%2C%20simple%20rural%20setting%2C%20grandparents%20nearby%2C%20warm%20touching%20scene%2C%20innocent%20child%20portrait%2C%20soft%20natural%20lighting%2C%20heartwarming%20photography%20style&width=400&height=400&seq=infant003&orientation=squarish",
    thankYouMessage: "我会用一生来感谢您的善良！",
    status: "active",
    receivedGifts: ["奶粉 × 1罐"],
  },
  {
    id: "inf004",
    name: "小莲",
    age: "4个月",
    village: "广西壮族自治区百色市田林县",
    province: "广西",
    story: "小莲是家中第三个孩子，家庭负担沉重。妈妈营养不良导致母乳不足，小莲经常因饥饿哭泣。村里的老师说，如果能得到帮助，小莲将来一定是个聪明的孩子。",
    needs: ["奶粉", "营养辅食", "感恩教育书"],
    goalAmount: 800,
    raisedAmount: 320,
    donors: 12,
    image: "https://readdy.ai/api/search-image?query=sweet%20Chinese%20baby%20girl%20in%20simple%20village%20home%2C%20tiny%20delicate%20features%2C%20wrapped%20in%20colorful%20traditional%20fabric%2C%20peaceful%20sleeping%20expression%2C%20warm%20gentle%20light%2C%20touching%20rural%20infant%20portrait%2C%20soft%20beautiful%20photography&width=400&height=400&seq=infant004&orientation=squarish",
    thankYouMessage: "您的爱是我人生中最美好的礼物！",
    status: "active",
    receivedGifts: [],
  },
  {
    id: "inf005",
    name: "小虎",
    age: "7个月",
    village: "湖南省湘西土家族苗族自治州古丈县",
    province: "湖南",
    story: "小虎的妈妈在他出生后不久离家出走，爸爸一人打工养家。小虎由邻居奶奶帮忙照看，每天只能喝稀米汤。小虎特别爱笑，每次有人逗他，他都会露出甜甜的笑容。",
    needs: ["奶粉", "图画书", "营养品"],
    goalAmount: 1100,
    raisedAmount: 880,
    donors: 27,
    image: "https://readdy.ai/api/search-image?query=happy%20smiling%20Chinese%20baby%20boy%20in%20rural%20village%2C%20chubby%20cheeks%2C%20bright%20smile%2C%20simple%20wooden%20home%20background%2C%20warm%20sunlight%2C%20joyful%20innocent%20child%20portrait%2C%20heartwarming%20photography%2C%20natural%20gentle%20tones&width=400&height=400&seq=infant005&orientation=squarish",
    thankYouMessage: "谢谢您让我的童年充满了爱与温暖！",
    status: "active",
    receivedGifts: ["奶粉 × 2罐", "图画书 × 1本"],
  },
  {
    id: "inf006",
    name: "小雪",
    age: "5个月",
    village: "甘肃省定西市通渭县",
    province: "甘肃",
    story: "小雪出生在西北最贫困的地区之一，家中连基本的生活用品都难以保障。妈妈因为营养不良，奶水很少。小雪的眼睛像星星一样闪亮，充满了对未来的希望。",
    needs: ["奶粉", "婴儿衣物", "感恩教育书"],
    goalAmount: 900,
    raisedAmount: 180,
    donors: 8,
    image: "https://readdy.ai/api/search-image?query=precious%20Chinese%20baby%20girl%20in%20northwest%20rural%20village%2C%20delicate%20innocent%20face%2C%20simple%20warm%20clothing%2C%20lying%20on%20traditional%20kang%20bed%2C%20soft%20winter%20light%2C%20touching%20heartwarming%20infant%20portrait%2C%20gentle%20beautiful%20photography&width=400&height=400&seq=infant006&orientation=squarish",
    thankYouMessage: "您的爱心是照亮我人生的第一束光！",
    status: "new",
    receivedGifts: [],
  },
];

export const recentDonors = [
  { name: "王**（彩票中奖者）", amount: 5000, gift: "奶粉礼包 × 10套", time: "2分钟前", avatar: "ri-vip-crown-fill", color: "text-yellow-500", platform: "lottery" },
  { name: "李**（企业家）", amount: 10000, gift: "爱心书籍礼盒 × 20套", time: "15分钟前", avatar: "ri-building-fill", color: "text-red-500", platform: "business" },
  { name: "张**（YouTube达人）", amount: 3000, gift: "奶粉 + 图画书套装", time: "1小时前", avatar: "ri-youtube-fill", color: "text-red-600", platform: "youtube" },
  { name: "陈**（TikTok明星）", amount: 8000, gift: "全套婴儿用品礼包", time: "3小时前", avatar: "ri-tiktok-fill", color: "text-gray-800", platform: "tiktok" },
  { name: "刘**（微信大V）", amount: 2000, gift: "感恩教育书籍套装", time: "5小时前", avatar: "ri-wechat-fill", color: "text-green-600", platform: "wechat" },
  { name: "赵**（抖音达人）", amount: 4500, gift: "奶粉礼包 × 8套", time: "昨天", avatar: "ri-music-fill", color: "text-pink-500", platform: "douyin" },
  { name: "孙**（富商）", amount: 20000, gift: "爱心大礼包 × 30套", time: "昨天", avatar: "ri-money-dollar-circle-fill", color: "text-amber-500", platform: "business" },
  { name: "周**（彩票中奖者）", amount: 6000, gift: "奶粉 + 营养品套装", time: "2天前", avatar: "ri-vip-crown-fill", color: "text-yellow-500", platform: "lottery" },
];

export const donationStats = {
  totalDonors: 1286,
  totalAmount: 2340000,
  infantsHelped: 847,
  giftsDelivered: 3420,
};

export const donationPackages = [
  {
    id: "pkg1",
    name: "爱心奶粉包",
    price: 298,
    icon: "ri-heart-line",
    color: "from-pink-400 to-rose-500",
    items: ["进口奶粉 × 2罐", "营养辅食 × 1套", "爱心卡片 × 1张"],
    desc: "为婴儿提供一个月的基本营养",
    popular: false,
  },
  {
    id: "pkg2",
    name: "成长礼物包",
    price: 498,
    icon: "ri-gift-line",
    color: "from-amber-400 to-orange-500",
    items: ["进口奶粉 × 3罐", "图画书 × 3本", "感恩教育书 × 1本", "爱心卡片 × 1张"],
    desc: "奶粉+书籍，滋养身心共同成长",
    popular: true,
  },
  {
    id: "pkg3",
    name: "天使守护包",
    price: 998,
    icon: "ri-shield-star-line",
    color: "from-red-500 to-red-700",
    items: ["进口奶粉 × 6罐", "图画书 × 5本", "感恩教育书 × 2本", "婴儿衣物 × 1套", "专属感谢信 + 婴儿照片"],
    desc: "三个月全方位守护，收到婴儿照片和感谢信",
    popular: false,
  },
  {
    id: "pkg4",
    name: "自定义金额",
    price: 0,
    icon: "ri-hand-heart-line",
    color: "from-emerald-400 to-green-600",
    items: ["按您的心意捐赠", "100%用于购买物资", "收到收据和婴儿照片"],
    desc: "随心捐赠，每一分都充满爱",
    popular: false,
  },
];
